import { z } from "zod";
import { LookupListPage } from "@/pages/admin/lookups/LookupListPage";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

interface Row { productTypeId: number; name: string; deleted: boolean; }
const schema = z.object({
  name: z.string().min(1).max(100),
  deleted: z.boolean(),
});
type Form = z.infer<typeof schema>;

export function BomProductTypesPage() {
  return <LookupListPage<Row, Form>
    title="Product types"
    apiPath="/api/lookups/bom-product-types"
    schema={schema}
    rowKey={(r) => r.productTypeId}
    columns={[
      { id: "id", header: "ID", accessor: (r) => r.productTypeId },
      { id: "name", header: "Name", accessor: (r) => r.name },
    ]}
    toFormValues={(r) => ({ name: r.name, deleted: r.deleted })}
    toApiBody={(f) => f}
    blankFormValues={{ name: "", deleted: false }}
    fields={(f) => (
      <div className="space-y-3">
        <div><Label htmlFor="n">Name</Label><Input id="n" {...f.register("name")} /></div>
        <Button type="submit">Save</Button>
      </div>
    )}
  />;
}
